export const ExitIcon = defineComponent({
  setup() {
    return () => (
      <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18" fill="none">
        <path
          d="M0.739379 16.8743C0.882646 17.0208 1.07696 17.1032 1.27957 17.1032H10.0402C10.5495 17.1032 10.9624 16.6903 10.9624 16.181V12.4243H9.44612L9.43455 15.5403H2.04351V2.25038H9.43455V5.59856H10.9624V1.46894C10.9624 1.26169 10.8819 1.06293 10.7387 0.916378C10.5954 0.76983 10.4011 0.6875 10.1985 0.6875H1.27957C1.07696 0.6875 0.882646 0.76983 0.739379 0.916378C0.596112 1.06293 0.515625 1.26169 0.515625 1.46894V16.3217C0.515625 16.529 0.596112 16.7278 0.739379 16.8743Z"
          fill="var(--colors-bg-icon-secondary)"
        />
        <path
          d="M12.5856 11.8947L13.6731 12.9821L17.5157 9.1395L13.6731 5.29688L12.5856 6.38434L14.5723 8.37097H7.14062V9.90802H14.5723L12.5856 11.8947Z"
          fill="var(--colors-bg-icon-secondary)"
        />
      </svg>
    )
  },
})
